import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

export const ImportExcelModal = (props) => {
  const { t } = useTranslation();
  const { setImportfile, readExcel, importfile } = props;
  const fileInputRef = useRef(null);

  const clearFile = () => {
    setImportfile?.(null);
    if (fileInputRef.current) fileInputRef.current.value = '';
  };

  useEffect(() => {
    const modal = document.getElementById('ImportModal');
    if (!modal) return undefined;
    const onHidden = () => clearFile();
    modal.addEventListener('hidden.bs.modal', onHidden);
    return () => modal.removeEventListener('hidden.bs.modal', onHidden);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSubmit = () => {
    readExcel?.();
    clearFile();
  };

  return (
    <div
      className="modal fade import-modal"
      id="ImportModal"
      tabIndex={-1}
      aria-labelledby="ImportModalLabel"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-body">
            <div className="import-modal-choose-file">
              {t('choose file')}
              <input
                ref={fileInputRef}
                type="file"
                accept=".xlsx,.xls,.csv"
                onChange={(e) => {
                  const file = e.target.files[0];
                  setImportfile(file);
                }}
                name="files"
              />
            </div>
            <div className="import-modal-file  w-100">
              {importfile?.name}
            </div>
          </div>
          <div id="clickonme" className="modal-footer">
            <button
              type="button"
              onClick={handleSubmit}
              data-bs-dismiss="modal"
              className="btn modal-content-yes"
            >
              {t('Submit')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
